import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { FileRecord } from "@/shared/domain/files";

type DeleteFileMutationArgs = {
  file: FileRecord;
};

export function useDeleteFileMutation(): UseMutationResult<
  void,
  unknown,
  DeleteFileMutationArgs
> {
  const { files: fileService } = useDomainServices();
  return useMutation<void, unknown, DeleteFileMutationArgs>({
    mutationFn: ({ file }) => {
      return fileService.deleteFile(file.file_id);
    },
  });
}
